'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var unlaunchedVenuesByCity = exports.unlaunchedVenuesByCity = {
  albuquerque: {
    'nm-juniors-facility-alexander-boulevard-northeast-albuquerque': {
      venue_id: 14407,
      venue_name: 'NM Juniors Facility',
      url: 'https://nmjuniorsfacility.com\t\t\t',
      normalized_address: '4382 Alexander Blvd NE, Albuquerque, NM 87107, USA',
      venue_phone: '+18888888888',
      venue_email: 'info@nmjuniorsfacility.com',
      street_number: '4382',
      street: 'Alexander Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.130566,
      lng: -106.618231,
      genre: ['Sports']
    },
    'crunch---albuquerque-juan-tabo-boulevard-northeast-albuquerque': {
      venue_id: 14223,
      venue_name: 'Crunch - Albuquerque',
      url: 'https://www.crunchalbuquerque.com/',
      normalized_address: 'Juan Tabo Blvd NE, Albuquerque, NM 87123, USA',
      venue_phone: '+15053959090',
      venue_email: 'manager@crunchalbuquerque.com',
      street_number: '840',
      street: 'Juan Tabo Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87123',
      description: '',
      lat: 35.0852103,
      lng: -106.5147585,
      genre: ['Gym', 'HIIT', 'Martial Arts', 'Strength Training', 'Dance', 'Yoga', 'Pilates', 'Personal Training']
    },
    '3h-fitness-montao-road-northeast-albuquerque': {
      venue_id: 14174,
      venue_name: '3H Fitness',
      url: 'http://3h-fitness.com/',
      normalized_address: '413 Montaño Rd NE, Albuquerque, NM 87107, USA',
      venue_phone: '+15054332667',
      venue_email: 'FWC3H@hotmail.com',
      street_number: '413',
      street: 'Montaño Road Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.1368859,
      lng: -106.6264752,
      genre: ['Gym', 'HIIT', 'Strength Training', 'Wellness']
    },
    'abq-tumbling-aspen-avenue-northwest-albuquerque': {
      venue_id: 14422,
      venue_name: 'ABQ Tumbling',
      url: 'https://abqtumbling.com/',
      normalized_address: '1701 Aspen Ave NW, Albuquerque, NM 87104, USA',
      venue_phone: '+15052473547',
      venue_email: 'info@abqtumbling.com',
      street_number: '1701',
      street: 'Aspen Avenue Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87104',
      description: '',
      lat: 35.1043287,
      lng: -106.6623792,
      genre: ['Strength Training']
    },
    'valley-high-gym-albuquerque': {
      venue_id: 14438,
      venue_name: 'Valley High Gym',
      url: 'http://www.valleyhighgym.com',
      normalized_address: 'LOS RNCHS ABQ, NM 87107, USA',
      venue_phone: '+18888888888',
      venue_email: 'info@valleyhighgym.com\t\t\t',
      street_number: null,
      street: null,
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.1254261,
      lng: -106.6609919,
      genre: ['Gym']
    },
    'defined-fitness-san-mateo-mcleod-road-northeast-albuquerque': {
      venue_id: 14280,
      venue_name: 'Defined Fitness San Mateo',
      url: 'http://www.defined.com/',
      normalized_address: '4930 McLeod Rd NE, Albuquerque, NM 87109, USA',
      venue_phone: '+15058887097',
      venue_email: 'jblotsky@defined.co',
      street_number: '4930',
      street: 'McLeod Road Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.1382,
      lng: -106.5882541,
      genre: ['Strength Training', 'HIIT', 'Pilates', 'Cycling', 'Yoga', 'Dance', 'Martial Arts', 'Personal Training']
    },
    'crossfit-albuquerque-eagle-rock-avenue-northeast-albuquerque': {
      venue_id: 14443,
      venue_name: 'CrossFit Albuquerque',
      url: 'http://www.crossfitalbuquerque.com/',
      normalized_address: '6501 Eagle Rock Ave NE, Albuquerque, NM 87113, USA',
      venue_phone: '+15055071749',
      venue_email: 'info@crossfitalbuquerque.com',
      street_number: '6501',
      street: 'Eagle Rock Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87113',
      description: '',
      lat: 35.18783210000001,
      lng: -106.5733694,
      genre: ['Strength Training']
    },
    'abq-kickboxing-luttrell--yee-mma-richmond-drive-northeast-albuquerque': {
      venue_id: 14319,
      venue_name: 'Abq Kickboxing Luttrell / YEE MMA',
      url: 'http://www.abqkickboxing.com/',
      normalized_address: 'A, 2820 Richmond Dr NE, Albuquerque, NM 87107, USA',
      venue_phone: '+15052655922',
      venue_email: 'abqkbinfo@gmail.com',
      street_number: '2820',
      street: 'Richmond Drive Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.113703,
      lng: -106.610668,
      genre: ['Boxing', 'Martial Arts', 'Strength Training']
    },
    'ufc-gym-san-mateo-boulevard-northeast-albuquerque': {
      venue_id: 14169,
      venue_name: 'UFC Gym',
      url: 'http://ufcgym.com/albuquerque',
      normalized_address: '6300 San Mateo Blvd NE, Albuquerque, NM 87109, USA',
      venue_phone: '+15053414269',
      venue_email: 'abqgm@ufcgym.com',
      street_number: '6300',
      street: 'San Mateo Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.1488853,
      lng: -106.5855135,
      genre: ['Gym', 'Boxing', 'Martial Arts', 'Personal Training']
    },
    'the-open-gym-albuquerque-wyoming-boulevard-northeast-albuquerque': {
      venue_id: 14289,
      venue_name: 'The Open Gym Albuquerque',
      url: 'http://theopengym.com/',
      normalized_address: '4200 Wyoming Blvd NE, Albuquerque, NM 87111, USA',
      venue_phone: '+15052992475',
      venue_email: 'info@theopengym.com',
      street_number: '4200',
      street: 'Wyoming Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87111',
      description: '',
      lat: 35.1287805,
      lng: -106.54984,
      genre: ['Strength Training', 'Yoga', 'Dance', 'Martial Arts', 'Gym']
    },
    'bear-canyon-crossfit-osuna-road-northeast-albuquerque': {
      venue_id: 14372,
      venue_name: 'Bear Canyon Crossfit',
      url: 'http://bearcanyoncrossfit.com/',
      normalized_address: '9533 Osuna Rd NE, Albuquerque, NM 87111, USA',
      venue_phone: '+15052932101',
      venue_email: 'bearcanyoncrossfit@yahoo.com',
      street_number: '9533',
      street: 'Osuna Road Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87111',
      description: '',
      lat: 35.1369085,
      lng: -106.5364366,
      genre: ['Gym', 'HIIT', 'Personal Training', 'Strength Training']
    },
    'snap-fitness-night-whisper-road-northwest-albuquerque': {
      venue_id: 14120,
      venue_name: 'Snap Fitness',
      url: 'https://www.snapfitness.com/gyms/albuquerque-nm-87114/508',
      normalized_address: '5740 Night Whisper Rd NW, Albuquerque, NM 87114, USA',
      venue_phone: '+15058905377',
      venue_email: 'abq3@snapfitness.com',
      street_number: '5740',
      street: 'Night Whisper Road Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87114',
      description: null,
      lat: 35.2160145,
      lng: -106.6984533,
      genre: ['Gym', 'HIIT', 'Strength Training', 'Personal Training']
    },
    'bioletics-gym-san-mateo-boulevard-northeast-albuquerque': {
      venue_id: 14186,
      venue_name: 'Bioletics gym',
      url: 'http://www.bioleticsgym.com/',
      normalized_address: '6300 San Mateo Blvd NE, Albuquerque, NM 87109, USA',
      venue_phone: '+18888888888',
      venue_email: 'info@bioleticsgym.com',
      street_number: '6300',
      street: 'San Mateo Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.14896300000001,
      lng: -106.584779,
      genre: ['Gym']
    },
    'powerflex-gym-4th-street-northwest-albuquerque': {
      venue_id: 14170,
      venue_name: 'Powerflex Gym',
      url: 'http://www.powerflexgym.com/',
      normalized_address: '6601 4th St NW, Albuquerque, NM 87107, USA',
      venue_phone: '+15053691011',
      venue_email: 'info@powerflexgym.com',
      street_number: '6601',
      street: '4th Street Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.1539884,
      lng: -106.6403492,
      genre: ['Gym', 'Personal Training']
    },
    'sport-and-life-fitness-wyoming-boulevard-northeast-albuquerque': {
      venue_id: 14374,
      venue_name: 'Sport and Life Fitness',
      url: 'https://sportandlifefitness.com/',
      normalized_address: '5901 Wyoming Blvd NE, Albuquerque, NM 87109, USA',
      venue_phone: '+13057205822',
      venue_email: 'info@sportandlifefitness.com',
      street_number: '5901',
      street: 'Wyoming Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.1472986,
      lng: -106.5567841,
      genre: ['Gym', 'Sports', 'Strength Training']
    },
    'dr-fit-pan-american-freeway-northeast-albuquerque': {
      venue_id: 14165,
      venue_name: 'DR. Fit',
      url: 'http://dr.fit.com/',
      normalized_address: '6203 Pan American Fwy NE, Albuquerque, NM 87109, USA',
      venue_phone: '+18888888888',
      venue_email: 'info@dr.fit.com',
      street_number: '6203',
      street: 'Pan American Freeway Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.1527691,
      lng: -106.5906381,
      genre: ['Gym']
    },
    'liberty-gym-jefferson-street-northeast-albuquerque': {
      venue_id: 14315,
      venue_name: 'Liberty Gym',
      url: 'http://www.libertygym.com/',
      normalized_address: '2401 Jefferson St NE, Albuquerque, NM 87110, USA',
      venue_phone: '+15058848012',
      venue_email: 'info@libertygym.com',
      street_number: '2401',
      street: 'Jefferson Street Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87110',
      description: '',
      lat: 35.1058229,
      lng: -106.5938169,
      genre: ['Strength Training', 'Personal Training', 'Gym']
    },
    'designer-bodies-world-class-gym-coors-boulevard-northwest-albuquerque': {
      venue_id: 14181,
      venue_name: "Designer Bodies 'WORLD CLASS GYM'",
      url: 'http://www.designerbodies.com/',
      normalized_address: '19 Coors Blvd NW, Albuquerque, NM 87121, USA',
      venue_phone: '+15058991700',
      venue_email: 'Info@DesignerBodies.com ',
      street_number: '10701',
      street: 'Coors Boulevard Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87114',
      description: '',
      lat: 35.204798,
      lng: -106.64764,
      genre: ['Gym', 'Personal Training', 'Strength Training']
    },
    'legion-iron-hazeldine-avenue-southeast-albuquerque': {
      venue_id: 14369,
      venue_name: 'Legion Iron',
      url: 'http://www.legionironnm.com/',
      normalized_address: '901 Hazeldine Ave SE, Albuquerque, NM 87106, USA',
      venue_phone: '+15052187816',
      venue_email: 'info@legioniron.com',
      street_number: '901',
      street: 'Hazeldine Avenue Southeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87106',
      description: '',
      lat: 35.076973,
      lng: -106.6372586,
      genre: ['Gym', 'Strength Training']
    },
    'ck-fitness-adams-street-southeast-albuquerque': {
      venue_id: 14367,
      venue_name: 'cK Fitness',
      url: 'https://www.ckfitness.com/',
      normalized_address: '152 Adams St SE, Albuquerque, NM 87108, USA',
      venue_phone: '+18888888888',
      venue_email: 'info@ckfitness.com',
      street_number: '152',
      street: 'Adams Street Southeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87108',
      description: '',
      lat: 35.0777985,
      lng: -106.59448,
      genre: ['Gym']
    },
    'planet-fitness-las-estancias-court-albuquerque': {
      venue_id: 14127,
      venue_name: 'Planet Fitness',
      url: 'http://www.planetfitness.com/gyms/albuquerque-south-coors-nm-1091',
      normalized_address: '3725 Las Estancias Ct, Albuquerque, NM 87105, USA',
      venue_phone: '+15056335505',
      venue_email: 'social@planetfitness.com',
      street_number: '3725',
      street: 'Las Estancias Court',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87105',
      description: '',
      lat: 35.0226175,
      lng: -106.7131122,
      genre: ['Strength Training']
    },
    'planet-fitness---albuquerque-menaul-and-carlisle-nm-menaul-boulevard-northeast-albuquerque': {
      venue_id: 14285,
      venue_name: 'Planet Fitness - Albuquerque (Menaul And Carlisle), NM',
      url: 'https://www.planetfitness.com/gyms/albuquerque-menaul-and-carlisle-nm',
      normalized_address: '3821 Menaul Blvd NE, Albuquerque, NM 87110, USA',
      venue_phone: '+15058720232',
      venue_email: 'social@planetfitness.com',
      street_number: '3821',
      street: 'Menaul Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87110',
      description: '',
      lat: 35.1101586,
      lng: -106.6009815,
      genre: ['Strength Training']
    },
    'ayuda-a-bajar-de-peso-336-adams-albuquerque': {
      venue_id: 14363,
      venue_name: 'Ayuda A Bajar De Peso',
      url: 'https://ayudaabajardepeso.com/',
      normalized_address: '334 336 Adams, Albuquerque, NM 87108, USA',
      venue_phone: '+18888888888',
      venue_email: 'info@ayudaabajardepeso.com',
      street_number: '334',
      street: '336 Adams',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87108',
      description: '',
      lat: 35.07461910000001,
      lng: -106.5939378,
      genre: ['Gym']
    },
    'abq-mobile-fitness-academy-ridge-road-northeast-albuquerque': {
      venue_id: 14300,
      venue_name: 'ABQ Mobile Fitness',
      url: 'https://abqmobilefitness.com',
      normalized_address: '10704 Academy Ridge Rd NE, Albuquerque, NM 87111, USA',
      venue_phone: '+15058502245',
      venue_email: 'info@abqmobilefitness.com',
      street_number: '10704',
      street: 'Academy Ridge Road Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87111',
      description: '',
      lat: 35.149266,
      lng: -106.520776,
      genre: ['Gym']
    },
    'del-webb-sandia-amenity-center-albuquerque': {
      venue_id: 14137,
      venue_name: 'Del Webb Sandia Amenity Center',
      url: 'http://www.delwebbmirehaven.com/',
      normalized_address: 'Albuquerque, NM 87120, USA',
      venue_phone: '+15054456304',
      venue_email: 'info@sandiaamenitycenter.com/',
      street_number: null,
      street: null,
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87120',
      description: '',
      lat: 35.10805240000001,
      lng: -106.7471746,
      genre: ['Gym', 'Outdoors', 'Sports', 'Yoga', 'Dance']
    },
    'g-force-gymnastics-academy-irving-boulevard-northwest-albuquerque': {
      venue_id: 14323,
      venue_name: 'G-Force Gymnastics Academy',
      url: 'http://www.gforcegymnastics.com/',
      normalized_address: '4487 Irving Blvd NW, Albuquerque, NM 87114, USA',
      venue_phone: '+15058987334',
      venue_email: 'gforce@gforcegymnastics.com',
      street_number: '4487',
      street: 'Irving Boulevard Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87114',
      description: '',
      lat: 35.197971,
      lng: -106.670257,
      genre: ['Gym']
    },
    'cantina-crossfit-copper-avenue-northeast-albuquerque': {
      venue_id: 14196,
      venue_name: 'Cantina Crossfit',
      url: 'https://cantinacrossfit.com/',
      normalized_address: '13600 Copper Ave NE, Albuquerque, NM 87123, USA',
      venue_phone: '+15052616359',
      venue_email: 'cantinacrossfit@gmail.com',
      street_number: '13600',
      street: 'Copper Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87123',
      description: '',
      lat: 35.07865,
      lng: -106.497885,
      genre: ['Gym', 'Yoga', 'Strength Training']
    },
    'snap-fitness-tramway-boulevard-northeast-albuquerque': {
      venue_id: 14205,
      venue_name: 'Snap Fitness',
      url: 'https://www.snapfitness.com/gyms/albuquerque-nm-87112/334',
      normalized_address: '1530 Tramway Blvd NE, Albuquerque, NM 87112, USA',
      venue_phone: '+15058391535',
      venue_email: 'abq@snapfitness.com',
      street_number: '1530',
      street: 'Tramway Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87112',
      description: '',
      lat: 35.095414,
      lng: -106.495664,
      genre: ['Personal Training', 'Martial Arts', 'Yoga', 'Gym', 'Strength Training']
    },
    'rebel-workout-central-avenue-southeast-albuquerque': {
      venue_id: 14424,
      venue_name: 'Rebel Workout',
      url: 'http://www.rebelworkout.com/',
      normalized_address: '300 Central Ave SE, Albuquerque, NM 87102, USA',
      venue_phone: '+15055038310',
      venue_email: 'info@rebelworkout.com',
      street_number: '300',
      street: 'Central Avenue Southeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87102',
      description: '',
      lat: 35.0834769,
      lng: -106.6444357,
      genre: ['Cycling', 'Strength Training']
    },
    'athletics--aesthetics-san-mateo-boulevard-northeast-albuquerque': {
      venue_id: 14184,
      venue_name: 'Athletics & Aesthetics',
      url: 'http://athleticsandaesthetics.com/',
      normalized_address: '6001 San Mateo Blvd NE STE G-3B, Albuquerque, NM 87109, USA',
      venue_phone: '+15059160142',
      venue_email: 'athletemedspa@gmail.com',
      street_number: '6001',
      street: 'San Mateo Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.145183,
      lng: -106.588181,
      genre: ['Gym', 'HIIT', 'Strength Training', 'Personal Training']
    },
    'powerflex-gym-eubank-boulevard-northeast-albuquerque': {
      venue_id: 14334,
      venue_name: 'Powerflex Gym',
      url: 'http://www.powerflexgym.com/',
      normalized_address: '1635 Eubank Blvd NE, Albuquerque, NM 87112, USA',
      venue_phone: '+15052991454',
      venue_email: 'info@powerflexgym.com',
      street_number: '1635',
      street: 'Eubank Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87112',
      description: '',
      lat: 35.0994371,
      lng: -106.5333866,
      genre: ['Personal Training', 'Gym']
    },
    'rio-grande-crossfit-wyoming-boulevard-northeast-albuquerque': {
      venue_id: 14388,
      venue_name: 'Rio Grande Crossfit',
      url: 'https://www.riograndecrossfit.org/',
      normalized_address: '5520 Wyoming Blvd NE, Albuquerque, NM 87109, USA',
      venue_phone: '+15053320565',
      venue_email: ' aaronb@jccabq.org',
      street_number: '5520',
      street: 'Wyoming Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87111',
      description: '',
      lat: 35.1427547,
      lng: -106.5494903,
      genre: ['Strength Training', 'Personal Training', 'Yoga', 'Gym']
    },
    'anytime-fitness-vista-oeste-northwest-albuquerque': {
      venue_id: 14213,
      venue_name: 'Anytime Fitness',
      url: 'https://www.anytimefitness.com/gyms/3426/Albuquerque-NM-87120?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=3426',
      normalized_address: '2115 Vista Oeste NW, Albuquerque, NM 87120, USA',
      venue_phone: '+15058390008',
      venue_email: 'abqnm@anytimefitness.com',
      street_number: '2115',
      street: 'Vista Oeste Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87120',
      description: '',
      lat: 35.1092452,
      lng: -106.7304737,
      genre: ['Strength Training']
    },
    'carlisle-gym-albuquerque': {
      venue_id: 14351,
      venue_name: 'Carlisle Gym',
      url: 'http://unm.edu/',
      normalized_address: 'Albuquerque, NM 87131, USA',
      venue_phone: '+15052770111',
      venue_email: 'recsvcs@unm.edu',
      street_number: null,
      street: null,
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87131',
      description: '',
      lat: 35.0836439,
      lng: -106.6226229,
      genre: ['Outdoors', 'Wellness', 'Sports']
    },
    'new-mexico-cactus-volleyball-club-washington-street-northeast-albuquerque': {
      venue_id: 14444,
      venue_name: 'New Mexico Cactus Volleyball Club',
      url: 'https://www.cactusvolleyball.com/',
      normalized_address: 'Washington St NE, Albuquerque, NM, USA',
      venue_phone: '+15058506244',
      venue_email: 'cactusclub@live.com',
      street_number: '8225',
      street: 'Washington Street Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87113',
      description: '',
      lat: 35.1761029,
      lng: -106.5972524,
      genre: ['Sports']
    },
    'gymnasium-san-antonio-drive-northeast-albuquerque': {
      venue_id: 14253,
      venue_name: 'Gymnasium',
      url: 'http://www.gracechurchabq.org/',
      normalized_address: '6901 San Antonio Dr NE, Albuquerque, NM 87109, USA',
      venue_phone: '+15058218800',
      venue_email: 'info@gracechurchabq.org',
      street_number: '6901',
      street: 'San Antonio Drive Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.1604869,
      lng: -106.5709744,
      genre: ['Sports', 'Gym']
    },
    'elevate-performance-health-wellness-singer-boulevard-northeast-albuquerque': {
      venue_id: 14161,
      venue_name: 'Elevate: Performance, Health, Wellness',
      url: 'https://www.elevatephw.com/',
      normalized_address: '3901 Singer Blvd NE, Albuquerque, NM 87109, USA',
      venue_phone: '+15053413411',
      venue_email: 'info@elevatephw.com',
      street_number: '3901',
      street: 'Singer Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.1451662,
      lng: -106.6003041,
      genre: ['Wellness', 'Strength Training', 'Personal Training']
    },
    'hb--lucille-horn-family-ymca-indian-school-road-albuquerque': {
      venue_id: 14288,
      venue_name: 'HB & Lucille Horn Family YMCA',
      url: 'http://www.ymcacnm.org/',
      normalized_address: '4901 Indian School Rd NE, Albuquerque, NM 87110, USA',
      venue_phone: '+15055951515',
      venue_email: 'info@ymcacnm.org',
      street_number: '4901',
      street: 'Indian School Road',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87110',
      description: '',
      lat: 35.1025451,
      lng: -106.590074,
      genre: ['Martial Arts', 'Gym', 'Dance', 'Cycling', 'Wellness', 'Yoga', 'Strength Training', 'Personal Training', 'Sports']
    },
    'training-for-warriors-albuquerque-commercial-street-northeast-albuquerque': {
      venue_id: 14410,
      venue_name: 'Training For Warriors Albuquerque',
      url: 'http://tfwabq.com/',
      normalized_address: '2105 Commercial St NE, Albuquerque, NM 87102, USA',
      venue_phone: '+15054015249',
      venue_email: 'tfw@tfwabq.com',
      street_number: '2105',
      street: 'Commercial Street Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87102',
      description: '',
      lat: 35.106406,
      lng: -106.642385,
      genre: ['Boxing', 'Strength Training', 'Martial Arts']
    },
    'ufc-gym-rio-rancho-rio-rancho-boulevard-southeast-albuquerque': {
      venue_id: 14173,
      venue_name: 'UFC GYM Rio Rancho',
      url: 'http://ufcgym.com/riorancho',
      normalized_address: '1650 Rio Rancho Blvd SE, Rio Rancho, NM 87124, USA',
      venue_phone: '+15059944269',
      venue_email: 'rioranchogm@ufcgym.com',
      street_number: '1650',
      street: 'Rio Rancho Boulevard Southeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87124',
      description: '',
      lat: 35.2335765,
      lng: -106.6551055,
      genre: ['Gym', 'Personal Training', 'Boxing', 'Martial Arts']
    },
    'highpoint-sports-and-wellness-landau-street-northeast-albuquerque': {
      venue_id: 14277,
      venue_name: 'Highpoint Sports and Wellness',
      url: 'http://sportsandwellness.com/Highpoint?utm_source=Google&utm_medium=GMB',
      normalized_address: '4300 Landau St NE, Albuquerque, NM 87111, USA',
      venue_phone: '+15052935820',
      venue_email: 'joinhighpoint@wellbridge.com',
      street_number: '4300',
      street: 'Landau Street Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87111',
      description: '',
      lat: 35.128664,
      lng: -106.49392,
      genre: ['Sports', 'Personal Training', 'Strength Training', 'Cycling', 'Yoga', 'Wellness', 'Dance', 'Pilates']
    },
    'sandia-crossfit-sawmill-road-albuquerque': {
      venue_id: 14327,
      venue_name: 'Sandia CrossFit',
      url: 'http://sandiacrossfit.com/',
      normalized_address: '1224 Sawmill Rd, Albuquerque, NM 87104, USA',
      venue_phone: '+15055083138',
      venue_email: 'info@sandiacrossfit.com',
      street_number: '1224',
      street: 'Sawmill Road',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87104',
      description: '',
      lat: 35.10051,
      lng: -106.6596829,
      genre: ['Gym', 'Strength Training']
    },
    'snap-fitness-carmel-avenue-northeast-albuquerque': {
      venue_id: 14379,
      venue_name: 'Snap Fitness',
      url: 'https://www.snapfitness.com/gyms/albuquerque-nm-87110/509',
      normalized_address: '7900 Carmel Ave NE, Albuquerque, NM 87122, USA',
      venue_phone: '+15053323944',
      venue_email: 'abq1@snapfitness.com',
      street_number: '7900',
      street: 'Carmel Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87122',
      description: '',
      lat: 35.1765603,
      lng: -106.5579342,
      genre: ['Gym', 'Personal Training', 'Strength Training']
    },
    'club-zen-sierra-drive-southeast-albuquerque': {
      venue_id: 14361,
      venue_name: 'CLUB ZEN',
      url: 'https://www.facebook.com/clubzenabq/',
      normalized_address: '223 Sierra Dr SE, Albuquerque, NM 87108, USA',
      venue_phone: '+15057951033',
      venue_email: 'info@clubzen.com',
      street_number: '223',
      street: 'Sierra Drive Southeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87108',
      description: '',
      lat: 35.0770568,
      lng: -106.5980739,
      genre: ['Wellness', 'Strength Training']
    },
    'anytime-fitness-mcmahon-nw-abq-mcmahon-boulevard-northwest-albuquerque': {
      venue_id: 14148,
      venue_name: 'Anytime Fitness McMahon NW ABQ',
      url: 'http://anytime-fitness-unsermcmahon.business.site/',
      normalized_address: '5708 McMahon Blvd NW, Albuquerque, NM 87114, USA',
      venue_phone: '+15058989022',
      venue_email: 'visionfit@icloud.com',
      street_number: '5708',
      street: 'McMahon Boulevard Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87114',
      description: '',
      lat: 35.211476,
      lng: -106.696251,
      genre: ['Gym', 'Strength Training']
    },
    'downtown-sports-and-wellness-first-plaza-center-northwest-albuquerque': {
      venue_id: 14279,
      venue_name: 'Downtown Sports and Wellness',
      url: 'http://sportsandwellness.com/Downtown?utm_source=Google&utm_medium=GMB',
      normalized_address: '40 First Plaza Center NW #76, Albuquerque, NM 87102, USA',
      venue_phone: '+15052421500',
      venue_email: 'joindowntown@wellbridge.com',
      street_number: '40',
      street: 'First Plaza Center Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87102',
      description: '',
      lat: 35.08587049999999,
      lng: -106.6493084,
      genre: ['Sports', 'Personal Training', 'Strength Training', 'Dance', 'Yoga', 'Cycling']
    },
    'defined-fitness-riverside-plaza-lane-albuquerque': {
      venue_id: 14307,
      venue_name: 'Defined Fitness',
      url: 'http://www.defined.com/',
      normalized_address: '6210 Riverside Plaza Ln, Albuquerque, NM 87120, USA',
      venue_phone: '+15058990086',
      venue_email: 'kbalog@defined.com',
      street_number: '6210',
      street: 'Riverside Plaza Lane',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87120',
      description: '',
      lat: 35.1545831,
      lng: -106.6805011,
      genre: ['Personal Training', 'Martial Arts', 'Dance', 'Strength Training', 'Yoga', 'Cycling', 'Pilates', 'HIIT']
    },
    'flavor-fitness-group-exercise-studio-constitution-avenue-northeast-albuquerque': {
      venue_id: 14352,
      venue_name: 'Flavor Fitness Group Exercise Studio',
      url: 'https://en.yelp.com.ph/biz/flavor-fitness-group-exercise-studio-albuquerque',
      normalized_address: '5206 Constitution Ave NE, Albuquerque, NM 87110, USA',
      venue_phone: '+15052806462',
      venue_email: 'info@flavorfitnessgroupexercisestudio.com',
      street_number: '5206',
      street: 'Constitution Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87110',
      description: '',
      lat: 35.0945016,
      lng: -106.587157,
      genre: ['Gym']
    },
    'the-hit-fit-club-golf-course-road-northwest-albuquerque': {
      venue_id: 14136,
      venue_name: 'The Hit Fit Club',
      url: 'http://www.thehitfitclub.com/',
      normalized_address: '8631 Golf Course Rd NW, Albuquerque, NM 87114, USA',
      venue_phone: '+15055031895',
      venue_email: 'thehitfitclub@outlook.com',
      street_number: '8631',
      street: 'Golf Course Road Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87114',
      description: '',
      lat: 35.18227079999999,
      lng: -106.6884925,
      genre: ['Boxing', 'Martial Arts', 'Strength Training']
    },
    'defined-fitness-juan-tabo-boulevard-northeast-albuquerque': {
      venue_id: 14283,
      venue_name: 'Defined Fitness',
      url: 'http://defined.com/',
      normalized_address: '3301 Juan Tabo Blvd NE, Albuquerque, NM 87111, USA',
      venue_phone: '+15052967000',
      venue_email: 'tbarrett@defined.com',
      street_number: '3301',
      street: 'Juan Tabo Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87111',
      description: '',
      lat: 35.1179478,
      lng: -106.5169101,
      genre: ['Personal Training', 'Martial Arts', 'Dance', 'Strength Training', 'Yoga', 'Cycling', 'Pilates', 'HIIT']
    },
    'edomingo-multigenerational-center-arvilla-avenue-northeast-albuquerque': {
      venue_id: 14390,
      venue_name: 'E.Domingo Multigenerational CENTER',
      url: 'http://northdomingo.weebly.com/',
      normalized_address: '10513 Arvilla Ave NE, Albuquerque, NM 87111, USA',
      venue_phone: '+15057646475',
      venue_email: 'miaguero@cabq.gov',
      street_number: '10513',
      street: 'Arvilla Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87111',
      description: '',
      lat: 35.122483,
      lng: -106.521905,
      genre: ['Yoga', 'Dance', 'Martial Arts', 'Pilates', 'Wellness', 'Strength Training', 'Sports']
    },
    'anytime-fitness-sage-road-southwest-albuquerque': {
      venue_id: 14123,
      venue_name: 'Anytime Fitness',
      url: 'https://www.anytimefitness.com/gyms/1051/Albuquerque-NM-87121?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=1051',
      normalized_address: '9550 Sage Rd SW Suite A105, Albuquerque, NM 87121, USA',
      venue_phone: '+15058219850',
      venue_email: 'AlbuquerqueNM2@anytimefitness.com',
      street_number: '9550',
      street: 'Sage Road Southwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87121',
      description: '',
      lat: 35.05528049999999,
      lng: -106.7380748,
      genre: ['Gym', 'HIIT', 'Strength Training']
    },
    'cedar-fit-albuquerque': {
      venue_id: 14183,
      venue_name: 'Cedar Fit',
      url: 'http://cedarfit.com/',
      normalized_address: 'LOS RNCHS ABQ, NM 87114, USA',
      venue_phone: '+15058568289',
      venue_email: 'getcedarfit@gmail.com ',
      street_number: null,
      street: null,
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87114',
      description: '',
      lat: 35.2035576,
      lng: -106.6535468,
      genre: ['Yoga', 'Martial Arts', 'Strength Training']
    },
    'stone-age-climbing-gym-cutler-avenue-northeast-albuquerque': {
      venue_id: 14295,
      venue_name: 'Stone Age Climbing Gym',
      url: 'https://climbstoneage.com/',
      normalized_address: '4130 Cutler Ave NE, Albuquerque, NM 87110, USA',
      venue_phone: '+15053412016',
      venue_email: 'climb@stoneagegym.com ',
      street_number: '4130',
      street: 'Cutler Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87110',
      description: '',
      lat: 35.1053465,
      lng: -106.5997758,
      genre: ['Strength Training', 'Personal Training', 'Martial Arts', 'Yoga']
    },
    'cheer-central-suns-nm-washington-street-northeast-albuquerque': {
      venue_id: 14447,
      venue_name: 'Cheer Central Suns NM',
      url: 'http://ccsuns.com/',
      normalized_address: 'Washington St NE, Albuquerque, NM, USA',
      venue_phone: '+15058210065',
      venue_email: 'info@cheercentralsuns.com',
      street_number: '8340',
      street: 'Washington Street Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87113',
      description: '',
      lat: 35.17918820000001,
      lng: -106.5945678,
      genre: ['Sports']
    },
    'duke-city-cages-1st-street-northwest-albuquerque': {
      venue_id: 14423,
      venue_name: 'Duke City Cages',
      url: 'http://dukecitycages.com/',
      normalized_address: '900 1st St NW, Albuquerque, NM 87102, USA',
      venue_phone: '+15055822163',
      venue_email: 'info@dukecitycages.com',
      street_number: '900',
      street: '1st Street Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87102',
      description: '',
      lat: 35.0920253,
      lng: -106.6459504,
      genre: ['Sports']
    },
    'precision-gymnastics-academy-mcleod-road-northeast-albuquerque': {
      venue_id: 14178,
      venue_name: 'Precision Gymnastics Academy',
      url: 'http://www.precisiongymnastics.net/',
      normalized_address: '4606 McLeod Rd NE, Albuquerque, NM 87109, USA',
      venue_phone: '+15053414002',
      venue_email: 'info@precisiongymnastics.net',
      street_number: '4606',
      street: 'McLeod Road Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.1369689,
      lng: -106.5920752,
      genre: ['Sports']
    },
    'geo-cache-dodge-avenue-northwest-albuquerque': {
      venue_id: 14152,
      venue_name: 'Geo Cache',
      url: 'https://geocache.com/',
      normalized_address: 'Dodge Ave NW, Albuquerque, NM 87114, USA',
      venue_phone: '+18888888888',
      venue_email: 'info@geocache.com',
      street_number: null,
      street: 'Dodge Avenue Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87114',
      description: '',
      lat: 35.21548260000001,
      lng: -106.6849578,
      genre: ['Gym']
    },
    'del-norte-sports-and-wellness-wyoming-boulevard-northeast-albuquerque': {
      venue_id: 14278,
      venue_name: 'Del Norte Sports and Wellness',
      url: 'http://sportsandwellness.com/DelNorte?utm_source=Google&utm_medium=GMB',
      normalized_address: '7120 Wyoming Blvd NE, Albuquerque, NM 87109, USA',
      venue_phone: '+15058570123',
      venue_email: 'joindelnorte@wellbridge.com',
      street_number: '7120',
      street: 'Wyoming Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.160908,
      lng: -106.5584778,
      genre: ['HIIT', 'Strength Training', 'Cycling', 'Martial Arts', 'Yoga', 'Pilates', 'Boxing', 'Barre', 'Dance', 'Sports', 'Wellness', 'Personal Training']
    },
    'ufc-gym-sevilla-avenue-northwest-albuquerque': {
      venue_id: 14413,
      venue_name: 'UFC Gym',
      url: 'http://ufcgym.com/AlbuquerqueWest',
      normalized_address: '5400 Sevilla Ave NW, Albuquerque, NM 87120, USA',
      venue_phone: '+15058984269',
      venue_email: 'abqwestgm@ufcgym.com',
      street_number: '5400',
      street: 'Sevilla Avenue Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87120',
      description: '',
      lat: 35.1405167,
      lng: -106.6997766,
      genre: ['Boxing', 'Martial Arts']
    },
    'hawks-ring-of-fire-gym-at-volcano-vista-high-school-rainbow-boulevard-northwest-albuquerque': {
      venue_id: 14124,
      venue_name: 'Hawks Ring Of Fire Gym at Volcano Vista High School',
      url: 'http://vvhs.aps.edu/',
      normalized_address: '8100 Rainbow Blvd NW, Albuquerque, NM 87114, USA',
      venue_phone: '+15058900343',
      venue_email: 'vickie.bannerman@aps.edu',
      street_number: '8100',
      street: 'Rainbow Boulevard Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87114',
      description: '',
      lat: 35.17704659999999,
      lng: -106.7326157,
      genre: ['Sports']
    },
    'nm-peak-fitness-jefferson-street-northeast-albuquerque': {
      venue_id: 14176,
      venue_name: 'Nm Peak Fitness',
      url: 'http://nmpeakfit.com/',
      normalized_address: '4805 Jefferson St NE, Albuquerque, NM 87109, USA',
      venue_phone: '+15059911184',
      venue_email: 'info@nmpeakfit.com',
      street_number: '4805',
      street: 'Jefferson Street Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.1358,
      lng: -106.593992,
      genre: ['Gym']
    },
    'anytime-fitness-juan-tabo-boulevard-northeast-albuquerque': {
      venue_id: 14349,
      venue_name: 'Anytime Fitness',
      url: 'https://www.anytimefitness.com/gyms/622/Albuquerque-NM-87111?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=622',
      normalized_address: '5809 Juan Tabo Blvd NE suite e, Albuquerque, NM 87111, USA',
      venue_phone: '+15059340524',
      venue_email: 'albuquerquenm@anytimefitness.com',
      street_number: '5809',
      street: 'Juan Tabo Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87111',
      description: '',
      lat: 35.14696,
      lng: -106.524946,
      genre: ['Strength Training', 'Dance', 'Yoga', 'HIIT']
    },
    'gravitypark-trampoline-arena-eagle-rock-avenue-northeast-albuquerque': {
      venue_id: 14282,
      venue_name: 'GravityPark Trampoline Arena',
      url: 'http://www.gravitypark.us/',
      normalized_address: '5300 Eagle Rock Ave NE, Albuquerque, NM 87113, USA',
      venue_phone: '+15054070954',
      venue_email: 'info@gravitypark.us',
      street_number: '5300',
      street: 'Eagle Rock Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87113',
      description: '',
      lat: 35.1869161,
      lng: -106.5852772,
      genre: ['Sports', 'Strength Training']
    },
    'mikes-gym-san-pedro-drive-northeast-albuquerque': {
      venue_id: 14344,
      venue_name: "Mike's Gym",
      url: 'http://www.mikesgym.org/',
      normalized_address: '1214 San Pedro Dr NE, Albuquerque, NM 87110, USA',
      venue_phone: '+15052554423',
      venue_email: 'info@mikesgym.com',
      street_number: '1214',
      street: 'San Pedro Drive Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87110',
      description: '',
      lat: 35.0900589,
      lng: -106.577134,
      genre: ['Gym']
    },
    'anytime-fitness-coal-avenue-southeast-albuquerque': {
      venue_id: 14342,
      venue_name: 'Anytime Fitness',
      url: 'https://www.anytimefitness.com/gyms/4484/Albuquerque-NM-87108?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=4484',
      normalized_address: '4212 Coal Ave SE, Albuquerque, NM 87108, USA',
      venue_phone: '+15053752020',
      venue_email: 'albuquerquenm@anytimefitness.com',
      street_number: '4212',
      street: 'Coal Avenue Southeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87108',
      description: '',
      lat: 35.0756649,
      lng: -106.5973421,
      genre: ['Gym', 'Strength Training', 'Personal Training']
    },
    'turning-point-strength-and-conditioning-san-francisco-road-northeast-albuquerque': {
      venue_id: 14454,
      venue_name: 'Turning Point Strength and Conditioning',
      url: 'http://www.turningpointgym.com/',
      normalized_address: '5620 San Francisco Rd NE, Albuquerque, NM 87109, USA',
      venue_phone: '+15052706941',
      venue_email: 'turningpointsc@gmail.com',
      street_number: '5620',
      street: 'San Francisco Road Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.1666567,
      lng: -106.5822607,
      genre: ['Gym', 'Strength Training']
    },
    'cia-strength-systems-2nd-street-southwest-albuquerque': {
      venue_id: 14230,
      venue_name: 'CIA Strength Systems',
      url: 'https://www.ciastrengthsystems.com/',
      normalized_address: '2331 2nd St SW, Albuquerque, NM 87102, USA',
      venue_phone: '+15052223115',
      venue_email: 'info@ciastrengthsystems.com',
      street_number: '2331',
      street: '2nd Street Southwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87102',
      description: '',
      lat: 35.058083,
      lng: -106.654043,
      genre: ['Gym']
    },
    'black-box-fitness-yale-boulevard-northeast-albuquerque': {
      venue_id: 14281,
      venue_name: 'Black Box Fitness',
      url: 'https://blackboxfitnessnm.com/',
      normalized_address: '4201 Yale Blvd NE, Albuquerque, NM 87107, USA',
      venue_phone: '+15053101003',
      venue_email: ' blackboxfitnessnm@gmail.com',
      street_number: '4201',
      street: 'Yale Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.128106,
      lng: -106.622547,
      genre: ['Strength Training', 'Sports', 'Gym']
    },
    'body-morph-fitness---entrenador-personal-rancho-lindo-court-northwest-albuquerque': {
      venue_id: 14437,
      venue_name: 'Body Morph Fitness - entrenador personal',
      url: 'https://www.bodymorphfitness.com/',
      normalized_address: '8108 Rancho Lindo Ct NW, Albuquerque, NM 87120, USA',
      venue_phone: '+15055854583',
      venue_email: 'info@bodymorphfitness.com',
      street_number: '8108',
      street: 'Rancho Lindo Court Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87120',
      description: '',
      lat: 35.177423,
      lng: -106.679702,
      genre: ['Gym']
    },
    'warriors-volleyball-club-nm-paseo-del-norte-northeast-albuquerque': {
      venue_id: 14449,
      venue_name: 'Warriors Volleyball Club NM',
      url: 'http://www.warriorsvolleyballnm.com/',
      normalized_address: '4320 Paseo Del Norte NE, Albuquerque, NM 87113, USA',
      venue_phone: '+15059290188',
      venue_email: 'warriorsvolleyball@yahoo.com',
      street_number: '4320',
      street: 'Paseo Del Norte Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87113',
      description: '',
      lat: 35.1730649,
      lng: -106.6007227,
      genre: ['Sports']
    },
    'la-luz-fitness-la-luz-trail-northeast-albuquerque': {
      venue_id: 14302,
      venue_name: 'La Luz Fitness',
      url: 'https://www.laluzfitness.com/',
      normalized_address: '1116 La Luz Trail NE, Albuquerque, NM 87122, USA',
      venue_phone: '+15054408900',
      venue_email: 'info@laluzfitness.com',
      street_number: '1116',
      street: 'La Luz Trail Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87122',
      description: '',
      lat: 35.209994,
      lng: -106.48191,
      genre: ['Gym']
    },
    'arvc-sports-centre-washington-street-northeast-albuquerque': {
      venue_id: 14458,
      venue_name: 'ARVC Sports Centre',
      url: 'http://www.arvcrebels.com/',
      normalized_address: '8500 Washington St NE, Albuquerque, NM 87113, USA',
      venue_phone: '+15053060272',
      venue_email: 'info@arvcrebels.com',
      street_number: '8500',
      street: 'Washington Street Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87113',
      description: '',
      lat: 35.181659,
      lng: -106.593858,
      genre: ['Sports']
    },
    'midtown-sports-and-wellness-prospect-avenue-northeast-albuquerque': {
      venue_id: 14304,
      venue_name: 'Midtown Sports and Wellness',
      url: 'http://sportsandwellness.com/Midtown?utm_source=Google&utm_medium=GMB',
      normalized_address: '4100 Prospect Ave NE, Albuquerque, NM 87110, USA',
      venue_phone: '+15058884811',
      venue_email: 'joinmidtown@wellbridge.com',
      street_number: '4100',
      street: 'Prospect Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87110',
      description: '',
      lat: 35.10684630000001,
      lng: -106.6001049,
      genre: ['HIIT', 'Strength Training', 'Cycling', 'Martial Arts', 'Yoga', 'Pilates', 'Barre', 'Boxing', 'Dance', 'Sports', 'Wellness', 'Personal Training']
    },
    'crossfit-petroglyph-high-assets-way-northwest-albuquerque': {
      venue_id: 14418,
      venue_name: 'CrossFit Petroglyph',
      url: 'http://www.crossfitpetroglyph.com/',
      normalized_address: 'High Assets Way NW, Albuquerque, NM 87120, USA',
      venue_phone: '+15055148804',
      venue_email: 'tory@crossfitpetroglyph.com',
      street_number: '9101',
      street: 'High Assets Way Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87120',
      description: '',
      lat: 35.1803299,
      lng: -106.6740457,
      genre: ['Strength Training', 'Gym']
    },
    'stetsons-messauge-place-bryn-mawr-drive-southeast-albuquerque': {
      venue_id: 14359,
      venue_name: 'Stetsons Messauge Place',
      url: 'http://stetsonsmessaugeplace.com\t\t\t',
      normalized_address: '127 Bryn Mawr Dr SE, Albuquerque, NM 87106, USA',
      venue_phone: '+18888888888',
      venue_email: 'info@stetsonsmessaugeplace.com',
      street_number: '127',
      street: 'Bryn Mawr Drive Southeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87106',
      description: '',
      lat: 35.079382,
      lng: -106.609904,
      genre: ['Gym']
    },
    '505-wrestling-club-7th-street-northwest-albuquerque': {
      venue_id: 14427,
      venue_name: '505 Wrestling Club',
      url: 'https://505wrestlingclub.com/',
      normalized_address: '1900 7th St NW, Albuquerque, NM 87102, USA',
      venue_phone: '+16144033877',
      venue_email: '505wrestlingclub@gmail.com',
      street_number: '1900',
      street: '7th Street Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87102',
      description: '',
      lat: 35.1037573,
      lng: -106.6524846,
      genre: ['Personal Training', 'Martial Arts', 'Sports']
    },
    'gold-cup-gymnastics-school-carmel-avenue-northeast-albuquerque': {
      venue_id: 14325,
      venue_name: 'Gold Cup Gymnastics School',
      url: 'http://www.goldcupgymnastics.com/',
      normalized_address: '6009 Carmel Ave NE, Albuquerque, NM 87113, USA',
      venue_phone: '+15058218417',
      venue_email: 'goldcupgym@aol.com\t',
      street_number: '6009',
      street: 'Carmel Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87113',
      description: '',
      lat: 35.177603,
      lng: -106.576749,
      genre: ['Sports', 'Strength Training']
    },
    'fit-studio-bogan-avenue-northeast-albuquerque': {
      venue_id: 14180,
      venue_name: 'F.I.T. Studio',
      url: 'http://www.fitstudioabq.com/',
      normalized_address: 'Bogan Ave NE, Albuquerque, NM 87109, USA',
      venue_phone: '+18888888888',
      venue_email: 'info@fitstudio.com',
      street_number: null,
      street: 'Bogan Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.1354188,
      lng: -106.594189,
      genre: ['Gym']
    },
    'kirtland-afb-west-fitness-center-aberdeen-drive-southeast-albuquerque': {
      venue_id: 14239,
      venue_name: 'Kirtland AFB West Fitness Center',
      url: 'http://kirtlandforcesupport.com/',
      normalized_address: '4500 Aberdeen Dr SE, Albuquerque, NM 87116, USA',
      venue_phone: '+15058461068',
      venue_email: 'info@kirtlandafbwestfitnesscenter.com',
      street_number: '4500',
      street: 'Aberdeen Drive Southeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87116',
      description: '',
      lat: 35.0553158,
      lng: -106.593367,
      genre: ['Gym']
    },
    'unm-indoor-practice-facility-albuquerque': {
      venue_id: 14243,
      venue_name: 'UNM Indoor Practice Facility',
      url: 'http://www.lobosocceracademy.com/summer-camp-series.cfm',
      normalized_address: 'UNM, NM 87106, USA',
      venue_phone: '+15059255728',
      venue_email: 'lobocamp@unm.edu',
      street_number: null,
      street: null,
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87106',
      description: '',
      lat: 35.0647599,
      lng: -106.6267306,
      genre: ['Sports']
    },
    'student-athlete-headquarters---sahq-lead-avenue-southeast-albuquerque': {
      venue_id: 14350,
      venue_name: 'Student Athlete Headquarters - SAHQ',
      url: 'http://www.sahq.org/\t\t\t',
      normalized_address: '1404 Lead Ave SE, Albuquerque, NM 87106, USA',
      venue_phone: '+15055085061',
      venue_email: 'hello@sahq.org',
      street_number: '1404',
      street: 'Lead Avenue Southeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87106',
      description: '',
      lat: 35.0784979,
      lng: -106.6314661,
      genre: ['Sports', 'Strength Training', 'Yoga']
    },
    'planet-fitness---albuquerque-nm-eubank-boulevard-northeast-albuquerque': {
      venue_id: 14218,
      venue_name: 'Planet Fitness - Albuquerque, NM',
      url: 'https://www.planetfitness.com/gyms/albuquerque-eubank-nm',
      normalized_address: '1518 Eubank Blvd NE, Albuquerque, NM 87112, USA',
      venue_phone: '+15055599000',
      venue_email: 'social@planetfitness.com',
      street_number: '1518',
      street: 'Eubank Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87112',
      description: '',
      lat: 35.096881,
      lng: -106.5319788,
      genre: ['Strength Training']
    },
    'doons-modesto-avenue-northeast-albuquerque': {
      venue_id: 14254,
      venue_name: 'Doons',
      url: 'https://www.doons.com',
      normalized_address: '9099 Modesto Ave NE, Albuquerque, NM 87122, USA',
      venue_phone: '+18888888888',
      venue_email: 'info@doons.com',
      street_number: '9099-8757',
      street: 'Modesto Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87122',
      description: '',
      lat: 35.1887782,
      lng: -106.5443661,
      genre: ['Gym']
    },
    'powerflex-gym-san-pedro-drive-northeast-albuquerque': {
      venue_id: 14255,
      venue_name: 'Powerflex Gym',
      url: 'http://powerflexgym.com/',
      normalized_address: '1214 San Pedro Dr NE, Albuquerque, NM 87110, USA',
      venue_phone: '+15055080718',
      venue_email: 'info@powerflexgym.com',
      street_number: '1214',
      street: 'San Pedro Drive Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87110',
      description: '',
      lat: 35.09006,
      lng: -106.5770627,
      genre: ['Gym']
    },
    'planet-fitness---albuquerque-irving-nm-irving-boulevard-northwest-albuquerque': {
      venue_id: 14122,
      venue_name: 'Planet Fitness - Albuquerque (Irving), NM',
      url: 'http://www.planetfitness.com/gyms/albuquerque-irving-nm-604',
      normalized_address: '4665 Irving Blvd NW, Albuquerque, NM 87114, USA',
      venue_phone: '+15058993707',
      venue_email: 'farrukh.zafar@planetfitness.com',
      street_number: '4665',
      street: 'Irving Boulevard Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87114',
      description: '',
      lat: 35.200327,
      lng: -106.67874,
      genre: ['Strength Training']
    },
    'riverpoint-sports-and-wellness-coors-boulevard-northwest-albuquerque': {
      venue_id: 14313,
      venue_name: 'Riverpoint Sports and Wellness',
      url: 'http://sportsandwellness.com/Riverpoint?utm_source=Google&utm_medium=GMB',
      normalized_address: '9190 Coors Blvd NW, Albuquerque, NM 87120, USA',
      venue_phone: '+15058973716',
      venue_email: 'aduran@wellbridge.com',
      street_number: '9190',
      street: 'Coors Boulevard Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87120',
      description: '',
      lat: 35.1793059,
      lng: -106.6683077,
      genre: ['Personal Training', 'Strength Training', 'Wellness', 'Sports', 'Pilates', 'Cycling', 'Dance', 'Barre', 'Yoga', 'HIIT']
    },
    'manzano-mesa-multi-gen-center-elizabeth-street-southeast-albuquerque': {
      venue_id: 14211,
      venue_name: 'Manzano Mesa Multi-Gen Center',
      url: 'http://manzanomesacenter.com/',
      normalized_address: '501 Elizabeth St SE, Albuquerque, NM 87123, USA',
      venue_phone: '+15052758731',
      venue_email: 'enunez@cabq.gov\t',
      street_number: '501',
      street: 'Elizabeth Street Southeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87123',
      description: '',
      lat: 35.06596489999999,
      lng: -106.5261077,
      genre: ['Sports']
    },
    'conditioned-by-kelly-tekin-wyoming-boulevard-northeast-albuquerque': {
      venue_id: 14383,
      venue_name: 'Conditioned by Kelly Tekin',
      url: 'http://www.conditionedbykellytekin.com/',
      normalized_address: '2621 Wyoming Blvd NE, Albuquerque, NM 87112, USA',
      venue_phone: '+15058145898',
      venue_email: 'tekingirl@gmail.com',
      street_number: '2621',
      street: 'Wyoming Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87112',
      description: '',
      lat: 35.1158513,
      lng: -106.5513329,
      genre: ['Gym', 'Personal Training', 'Strength Training']
    },
    'athlete-ready-pan-american-frontage-road-north-albuquerque': {
      venue_id: 14436,
      venue_name: 'Athlete Ready',
      url: 'http://athleteready.com/',
      normalized_address: '3520 Pan American Frontage Rd N, Albuquerque, NM 87107, USA',
      venue_phone: '+15054896314',
      venue_email: 'info@athleteready.com',
      street_number: '3520',
      street: 'Pan American Frontage Road North',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.1213406,
      lng: -106.622288,
      genre: ['Strength Training']
    },
    'planet-fitness-gibson-boulevard-southeast-albuquerque': {
      venue_id: 14234,
      venue_name: 'Planet Fitness',
      url: 'https://www.planetfitness.com/gyms/albuquerque-gibson-nm',
      normalized_address: '5401 Gibson Blvd SE, Albuquerque, NM 87108, USA',
      venue_phone: '+15052562500',
      venue_email: ' farrukh.zafar@planetfitness.com',
      street_number: '5401',
      street: 'Gibson Boulevard Southeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87108',
      description: '',
      lat: 35.0596254,
      lng: -106.5818344,
      genre: ['Strength Training']
    },
    'rise-basketball-school-diamond-mesa-trail-southwest-albuquerque': {
      venue_id: 14130,
      venue_name: 'RISE Basketball School',
      url: 'http://www.risebasketballschool.com/',
      normalized_address: '2300 Diamond Mesa Trail SW, Albuquerque, NM 87121, USA',
      venue_phone: '+16572067872',
      venue_email: 'risebasketballschool@gmail.com',
      street_number: '2300',
      street: 'Diamond Mesa Trail Southwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87121',
      description: '',
      lat: 35.044587,
      lng: -106.731703,
      genre: ['Sports']
    },
    'planet-fitness-alameda-boulevard-northeast-albuquerque': {
      venue_id: 14290,
      venue_name: 'Planet Fitness',
      url: 'https://www.planetfitness.com/gyms/albuquerque-alameda-nm',
      normalized_address: '4801 Alameda Blvd NE, Albuquerque, NM 87113, USA',
      venue_phone: '+15057978767',
      venue_email: 'social@planetfitness.com',
      street_number: '4801',
      street: 'Alameda Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87113',
      description: '',
      lat: 35.185139,
      lng: -106.5923197,
      genre: ['Strength Training']
    },
    'planet-fitness-montgomery-boulevard-northeast-albuquerque': {
      venue_id: 14328,
      venue_name: 'Planet Fitness',
      url: 'http://www.planetfitness.com/gyms/albuquerque-montgomery-nm-527',
      normalized_address: 'Montgomery Blvd NE, Albuquerque, NM 87111, USA',
      venue_phone: '+15052961300',
      venue_email: 'social@planetfitness.com',
      street_number: '11200',
      street: 'Montgomery Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87111',
      description: '',
      lat: 35.1295357,
      lng: -106.5144152,
      genre: ['Strength Training']
    },
    '505-volleyball-academy-paseo-del-norte-northeast-albuquerque': {
      venue_id: 14459,
      venue_name: '505 Volleyball Academy',
      url: 'http://505volleyball.com/',
      normalized_address: '4101 Paseo Del Norte NE, Albuquerque, NM 87113, USA',
      venue_phone: '+15053010621',
      venue_email: '505volleyballacademy@gmail.com',
      street_number: '4101',
      street: 'Paseo Del Norte Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87113',
      description: '',
      lat: 35.1753717,
      lng: -106.601218,
      genre: ['Sports']
    },
    'abq-circus-arts-5th-street-northwest-albuquerque': {
      venue_id: 14425,
      venue_name: 'ABQ Circus Arts',
      url: 'https://www.abqcircusarts.com/',
      normalized_address: '1715 5th St NW, Albuquerque, NM 87102, USA',
      venue_phone: '+15052804002',
      venue_email: 'abqcircusarts@gmail.com\t\t',
      street_number: '1715',
      street: '5th Street Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87102',
      description: '',
      lat: 35.10194749999999,
      lng: -106.6501066,
      genre: ['Sports', 'Personal Training']
    },
    'sandia-amenity-center-albuquerque': {
      venue_id: 14128,
      venue_name: 'Sandia Amenity Center',
      url: 'http://www.delwebbmirehaven.com/Amenities/Sandia_Center.htm',
      normalized_address: 'Albuquerque, NM 87120, USA',
      venue_phone: '+15054456304',
      venue_email: 'info@sandiaamenitycenter.com/',
      street_number: null,
      street: null,
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87120',
      description: '',
      lat: 35.107945,
      lng: -106.747451,
      genre: ['Sports', 'Outdoors', 'Gym']
    },
    'fit-nhb-lomas-boulevard-northeast-albuquerque': {
      venue_id: 14348,
      venue_name: 'Fit NHB',
      url: 'http://www.fitnhb.com/',
      normalized_address: '110 Lomas Blvd NE, Albuquerque, NM 87102, USA',
      venue_phone: '+15058333351',
      venue_email: 'fitnhb@aol.com',
      street_number: '110',
      street: 'Lomas Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87102',
      description: '',
      lat: 35.0903732,
      lng: -106.6452055,
      genre: ['Gym', 'Boxing', 'Martial Arts', 'Strength Training']
    },
    'body-elite-fitness-coors-boulevard-northwest-albuquerque': {
      venue_id: 14440,
      venue_name: 'Body Elite Fitness',
      url: 'https://www.facebook.com/BodyEliteFitnessNM/',
      normalized_address: '3300 Coors Blvd NW, Albuquerque, NM 87120, USA',
      venue_phone: '+15053216924',
      venue_email: 'info@bodyelitefitness.com',
      street_number: '3300',
      street: 'Coors Boulevard Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87120',
      description: '',
      lat: 35.1210758,
      lng: -106.7002339,
      genre: ['Strength Training', 'HIIT', 'Gym']
    },
    'anatomic-fitness-jefferson-street-northeast-albuquerque': {
      venue_id: 14194,
      venue_name: 'Anatomic Fitness',
      url: 'http://www.anatomicfitness.com/',
      normalized_address: '4081 Jefferson St NE Suite C, Albuquerque, NM 87109, USA',
      venue_phone: '+15055533831',
      venue_email: 'info@anatomicfitness.com',
      street_number: '4081',
      street: 'Jefferson Street Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.1354139,
      lng: -106.593995,
      genre: ['Gym']
    },
    'albuquerque-gymnastics-school-comanche-road-northeast-albuquerque': {
      venue_id: 14324,
      venue_name: 'Albuquerque Gymnastics School',
      url: 'http://www.agsgymnastics.com/',
      normalized_address: '10280 Comanche Rd NE, Albuquerque, NM 87111, USA',
      venue_phone: '+15052939570',
      venue_email: 'agsgym@live.com',
      street_number: '10280',
      street: 'Comanche Road Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87111',
      description: '',
      lat: 35.123212,
      lng: -106.5252859,
      genre: ['Sports']
    },
    'functional-fury-osuna-road-northwest-albuquerque': {
      venue_id: 14167,
      venue_name: 'Functional Fury',
      url: 'https://www.functionalfury.com/',
      normalized_address: '141 Osuna Rd NW, Albuquerque, NM 87107, USA',
      venue_phone: '+15053693170',
      venue_email: 'f_fury1@yahoo.com',
      street_number: '141',
      street: 'Osuna Road Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.1528689,
      lng: -106.6306731,
      genre: ['Gym', 'Personal Training', 'Strength Training']
    },
    'kratos-training-facility-princeton-drive-northeast-albuquerque': {
      venue_id: 14259,
      venue_name: 'Kratos Training Facility',
      url: 'http://kratosrapsrating.wixsite.com/kratostraining/staff',
      normalized_address: '2412 Princeton Dr NE, Albuquerque, NM 87107, USA',
      venue_phone: '+15054895395',
      venue_email: 'kratostrainingfacility@gmail.com\t',
      street_number: '2412',
      street: 'Princeton Drive Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.1102305,
      lng: -106.6200647,
      genre: ['Sports']
    },
    'ymca-comanche-road-northeast-albuquerque': {
      venue_id: 14385,
      venue_name: 'YMCA',
      url: 'http://www.ymcacnm.org/',
      normalized_address: '12500 Comanche Rd NE, Albuquerque, NM 87111, USA',
      venue_phone: '+15055951515',
      venue_email: 'info@ymcacnm.org',
      street_number: '12500',
      street: 'Comanche Road Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87111',
      description: '',
      lat: 35.1225873,
      lng: -106.499311,
      genre: ['Dance', 'Cycling', 'Yoga', 'Sports', 'Wellness', 'Strength Training', 'Martial Arts', 'Personal Training', 'Gym']
    },
    'herman-sanchez-community-center-william-street-southeast-albuquerque': {
      venue_id: 14214,
      venue_name: 'Herman Sanchez Community Center',
      url: 'https://www.cabq.gov/family/community-centers/community-center-locations/herman-sanchez-community-center',
      normalized_address: '1830 William St SE, Albuquerque, NM 87102, USA',
      venue_phone: '+15058481336',
      venue_email: 'acgomez@cabq.gov',
      street_number: '1830',
      street: 'William Street Southeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87102',
      description: '',
      lat: 35.0642976,
      lng: -106.6488509,
      genre: ['Sports', 'Strength Training', 'Dance', 'Gym']
    },
    '3twelve-strength--fitness-private-gym-rosemont-avenue-northeast-albuquerque': {
      venue_id: 14426,
      venue_name: '3Twelve Strength + Fitness Private Gym',
      url: 'http://www.3twelvegym.com/',
      normalized_address: '312 Rosemont Ave NE, Albuquerque, NM 87102, USA',
      venue_phone: '+15053555949',
      venue_email: '3twelvegym@gmail.com',
      street_number: '312',
      street: 'Rosemont Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87102',
      description: '',
      lat: 35.095003,
      lng: -106.641822,
      genre: ['Gym', 'Personal Training', 'Strength Training', 'Yoga']
    },
    'anytime-fitness---albuquerque-menaul-boulevard-northeast-albuquerque': {
      venue_id: 14402,
      venue_name: 'Anytime Fitness - Albuquerque',
      url: 'http://www.anytimefitness.com/gyms/3612/Albuquerque-NM-87107',
      normalized_address: '3301 Menaul Blvd NE, Albuquerque, NM 87107, USA',
      venue_phone: '+15052960000',
      venue_email: 'albuquerquenm@anytimefitness.com',
      street_number: '3301',
      street: 'Menaul Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.1105559,
      lng: -106.6076653,
      genre: ['Strength Training']
    },
    'duke-city-volleyball-academy-paseo-del-norte-boulevard-northeast-albuquerque': {
      venue_id: 14460,
      venue_name: 'Duke City Volleyball Academy',
      url: 'http://dukecityvb.com/sample-page/contact/',
      normalized_address: '4101 Paseo Del Norte Blvd NE, Albuquerque, NM 87113, USA',
      venue_phone: '+15053506534',
      venue_email: 'dukecityvb@gmail.com\t',
      street_number: '4101',
      street: 'Paseo Del Norte Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87113',
      description: '',
      lat: 35.1749654,
      lng: -106.5997304,
      genre: ['Sports']
    },
    'liftoff-comanche-road-northeast-albuquerque': {
      venue_id: 14267,
      venue_name: 'Liftoff',
      url: 'http://www.liftoff.com',
      normalized_address: 'Suite D-3, 2420 Comanche Rd NE, Albuquerque, NM 87107, USA',
      venue_phone: '+15054014586',
      venue_email: 'info@liftoff.com',
      street_number: '2420',
      street: 'Comanche Road Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.12367519999999,
      lng: -106.6161267,
      genre: ['Gym']
    },
    'planet-fitness-coors-boulevard-northwest-albuquerque': {
      venue_id: 14286,
      venue_name: 'Planet Fitness',
      url: 'http://www.planetfitness.com/gyms/albuquerque-coors-blvd-nm-512',
      normalized_address: '3301 Coors Blvd NW, Albuquerque, NM 87120, USA',
      venue_phone: '+15058334444',
      venue_email: 'social@planetfitness.com',
      street_number: '3301',
      street: 'Coors Boulevard Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87120',
      description: '',
      lat: 35.1192444,
      lng: -106.703166,
      genre: ['Strength Training']
    },
    'planet-fitness-4th-street-northwest-albuquerque': {
      venue_id: 14335,
      venue_name: 'Planet Fitness',
      url: 'http://www.planetfitness.com/gyms/albuquerque-4th-nm-275',
      normalized_address: '6211 4th St NW, Albuquerque, NM 87107, USA',
      venue_phone: '+15053419771',
      venue_email: 'social@planetfitness.com',
      street_number: '6211',
      street: '4th Street Northwest',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.1467762,
      lng: -106.6413918,
      genre: ['Strength Training']
    },
    'saga-gymnastics-candelaria-road-northeast-albuquerque': {
      venue_id: 14331,
      venue_name: 'SAGA Gymnastics',
      url: 'http://www.sagagymnastics.com/',
      normalized_address: '3400 Candelaria Rd NE, Albuquerque, NM 87107, USA',
      venue_phone: '+15058846949',
      venue_email: 'info@sagagym.com',
      street_number: '3400',
      street: 'Candelaria Road Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.11618230000001,
      lng: -106.60747,
      genre: ['Sports']
    },
    'the-burn-zone-hawkins-street-northeast-albuquerque': {
      venue_id: 14452,
      venue_name: 'The Burn Zone',
      url: 'http://www.burnzoneabq.com/',
      normalized_address: '3738 Hawkins St NE, Albuquerque, NM 87109, USA',
      venue_phone: '+18324741813',
      venue_email: 'info@burnzoneabq.com',
      street_number: '3738-C',
      street: 'Hawkins Street Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87109',
      description: '',
      lat: 35.1620484,
      lng: -106.602171,
      genre: ['Gym']
    },
    'new-mexico-sports-academy-princeton-drive-northeast-albuquerque': {
      venue_id: 14261,
      venue_name: 'New Mexico Sports Academy',
      url: 'http://nmsportsacademy.com/',
      normalized_address: '2412 Princeton Dr NE, Albuquerque, NM 87107, USA',
      venue_phone: '+15059330604',
      venue_email: 'nmsa15@yahoo.com\t',
      street_number: '2412',
      street: 'Princeton Drive Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87107',
      description: '',
      lat: 35.1102305,
      lng: -106.6200647,
      genre: ['Strength Training', 'Personal Training', 'Outdoors', 'Sports', 'Running']
    },
    'winks-gym-mma--fitness---smart-girl-self-defense-carmel-avenue-northeast-albuquerque': {
      venue_id: 14384,
      venue_name: "Wink's Gym MMA & Fitness - Smart Girl Self Defense",
      url: 'http://winksgym.com/',
      normalized_address: '7610 Carmel Ave NE, Albuquerque, NM 87122, USA',
      venue_phone: '+15058226326',
      venue_email: 'winksgym@hotmail.com',
      street_number: '7610',
      street: 'Carmel Avenue Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87122',
      description: '',
      lat: 35.17673910000001,
      lng: -106.5586517,
      genre: ['Martial Arts', 'Yoga', 'Strength Training']
    },
    'hd-fitness-studio-montgomery-boulevard-northeast-albuquerque': {
      venue_id: 14362,
      venue_name: 'HD Fitness Studio',
      url: 'http://www.hdfitnessnm.com/',
      normalized_address: '9050 Montgomery Blvd NE, Albuquerque, NM 87111, USA',
      venue_phone: '+15053621799',
      venue_email: 'info@hdfitnessnm.com',
      street_number: '9050',
      street: 'Montgomery Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87111',
      description: '',
      lat: 35.13028870000001,
      lng: -106.5424659,
      genre: ['Sports', 'Strength Training', 'Personal Training']
    },
    'eastdale-little-league-alameda-boulevard-northeast-albuquerque': {
      venue_id: 14442,
      venue_name: 'Eastdale Little League',
      url: 'http://www.edll.org/',
      normalized_address: '701 Alameda Blvd NE, Albuquerque, NM 87113, USA',
      venue_phone: '+15057979867',
      venue_email: 'eastdalell@gmail.com',
      street_number: '701',
      street: 'Alameda Boulevard Northeast',
      city: 'Albuquerque',
      state: 'New Mexico',
      postal_code: '87113',
      description: '',
      lat: 35.1862466,
      lng: -106.6001302,
      genre: ['Sports']
    }
  }
};

var regionsWithMSAs = exports.regionsWithMSAs = [['southwest', ['albuquerque']]];